module.exports = __webpack_public_path__ + "static/media/ema.43e47169.jpg";